import styled from 'styled-components';
import { DivWithShadowAlternate } from '@styled';
import { mediaQueries } from '@general/breakpoints';

export const InboxContainerStyled = styled(DivWithShadowAlternate)`
    flex-direction: column;
    min-height: auto;
    padding: 1rem;
    margin-bottom: 1rem;
    @media ${mediaQueries.md} {
        margin: 40px 0;
        padding: 22px 32px 32px 22px;
        display: flex;
        flex-direction: row;
        height: 650px;
    }
`;

export const SidebarStyled = styled.div`
    width: 100%;
    z-index: 1; // fixes issue with tooltips overlapping with window with fade-in-fast
    @media ${mediaQueries.md} {
        width: 35%;
        min-width: 300px;
        height: 100%;
    }
`;

export const ContainerMainStyled = styled.div`
    width: 100%;
    @media ${mediaQueries.md} {
        width: 65%;
        height: 100%;
    }
`;

export const ContainerMainInnerStyled = styled.div`
    margin-left: 12px;
`;

export const ConversationSearchContainerStyled = styled.div`
    margin: 10px 0 0 10px;
    @media ${mediaQueries.md} {
        margin: 10px 0 22px 10px;
    }
`;
